/**
 * @description This is the definition for enums used throughout the fuel applications logic
 * for iris-tools-api, fuel-channel-api, and iris-client projects.  They are also used, just
 * less frequently, in the iris-queue-processor, fuel-channel-update-lambda, and fuel-lambda
 * projects.
 *
 * Enums should be PascalCased for the name of the Enum, with properties being UPPER_CASE and
 * values being lowercase-with-dashes.
 *
 * eg.
 * export  enum MyEnum {
 *     MY_PROPERTY = 'my-property',
 *     VALUE_2 = 'value-2',
 *     VALUE_3 = 'value-3'
 * }
 */
/**
 * Types of Environments where fuel is Deployed.  Why isn't QA listed?
 */
export enum Enviroment {
  Dev = 'development',
  Prod = 'production',
}
export enum ElasticSearchUpdateType {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}
export enum ElasticResult {
  Created = 'created',
  Updated = 'updated',
}
export enum IsDeleted {
  False = 0,
  True = 1,
}
export enum ProgressStatus {
  Started = 'Started',
  Pending = 'Pending',
  InProgress = 'In Progress',
  Cancelled = 'Cancelled',
  Error = 'Error',
  Done = 'Done',
}
export enum LegacyJobStatus {
  Pending = 'Pending',
  InProgress = 'In Progress',
  Cancelled = 'Cancelled',
  Error = 'Error',
  Done = 'Done',
}
export enum CaptionsStatus {
  NotReady = 'Not Ready',
  Ready = 'Ready',
  Error = 'Error',
}
export enum JobType {
  Ingest = 'Ingest',
  Conform = 'Conform',
}
export enum ItemStatus {
  Ingesting = 'Ingesting',
  IngestFailed = 'IngestFailed',
  IngestCancelled = 'IngestCancelled',
  Ingested = 'Ingested',
  Draft = 'Draft',
  Publishing = 'Publishing',
  Published = 'Published',
  Deleted = 'Deleted',
}

/**
 * 1xx -- Informational.
 * 2xx -- Successful.
 * 3xx -- Redirection.
 * 4xx -- Client Error.
 * 5xx -- Server Error.
 *
 * @export
 * @enum {number}
 */
export const enum HttpStatusCode {
  OK_200 = 200,
  CREATED_201 = 201,
  ACCEPTED_202 = 202,
  NON_AUTHORITATIVE_INFORMATION_203 = 203,
  NO_CONTENT_204 = 204,
  RESET_CONTENT_205 = 205,
  PARTIAL_CONTENT_206 = 206,
  MULTIPLE_CHOICES_300 = 300,
  MOVED_PERMANENTLY_301 = 301,
  FOUND_302 = 302,
  SEE_OTHER_303 = 303,
  NOT_MODIFIED_304 = 304,
  USE_PROXY_305 = 305,
  TEMPORARY_REDIRECT_307 = 307,
  BAD_REQUEST_400 = 400,
  UNAUTHORIZED_401 = 401,
  PAYMENT_REQUIRED_402 = 402,
  FORBIDDEN_403 = 403,
  NOT_FOUND_404 = 404,
  METHOD_NOT_ALLOWED_405 = 405,
  NOT_ACCEPTABLE_406 = 406,
  PROXY_AUTHENTICATION_REQUIRED_407 = 407,
  REQUEST_TIMEOUT_408 = 408,
  CONFLICT_409 = 409,
  GONE_410 = 410,
  LENGTH_REQUIRED_411 = 411,
  PRECONDITION_FAILED_412 = 412,
  REQUEST_ENTITY_TOO_LARGE_413 = 413,
  REQUEST_URI_TOO_LONG_414 = 414,
  UNSUPPORTED_MEDIA_TYPE_415 = 415,
  REQUESTED_RANGE_NOT_SATISFIABLE_416 = 416,
  EXPECTATION_FAILED_417 = 417,
  UNPROCESSABLE_ENTITY_422 = 422,
  TOO_MANY_REQUESTS_429 = 429,
  INTERNAL_SERVER_ERROR_500 = 500,
  NOT_IMPLEMENTED_501 = 501,
  BAD_GATEWAY_502 = 502,
  SERVICE_UNAVAILABLE_503 = 503,
  GATEWAY_TIMEOUT_504 = 504,
  HTTP_VERSION_NOT_SUPPORTED_505 = 505,
}
export enum SearchJobType {
  ADD = 0,
  ERROR_ADD = 1,
  UPDATE = 2,
  ERROR_UPDATE = 3,
  DELETE = 4,
  ERROR_DELETE = 5,
}
export enum SearchIndex {
  Item = 'item',
  Job = 'job',
  ClipProject = 'clip_project',
}
export enum AccountStatus {
  Disabled = 0,
  Active = 1,
  Staging = 2,
  Deleted = 3,
}
export enum ItemReferrer {
  'STREAMING_ENGINE' = 0,
  'INGEST' = 1,
}
export enum SearchOutPutType {
  SIMPLE = 'simple',
  ADVANCE_LIST = 'advance-list',
  ADVANCE_THUMB = 'advance-thumb',
  ADVANCE_BASE_BALL = 'advance-base-ball',
  ADVANCE_MAP = 'advance-map',
}
export enum SearchFilters {
  ALL_WORD = 'all-word',
  EXACT_WORD = 'exact-word',
  ANY_WORD = 'any-word',
  VIDEO = 'video',
  AUDIO = 'audio',
  SCRIPT = 'script',
  STORY = 'story',
}
export enum StorageAdapterType {
  S3_BUCKET = 'AWS S3',
  FILE = 'File',
}
export enum StorageContentType {
  Source = 'Source',
}
export enum OrderBy {
  DESC = 'desc',
  ASC = 'asc',
}
export enum FuelPermissions {
  IngestView = 'ingest.view',
  IngestManage = 'ingest.manage',
  TransitionView = 'transition.view',
  TransitionManage = 'transition.manage',
  LiveProgramView = 'liveprogram.view',
  LiveProgramManage = 'liveprogram.manage',
  ChannelView = 'channel.view',
  ChannelManage = 'channel.manage',
  ClipView = 'clip.view',
  ClipManage = 'clip.manage',
  AdminView = 'admin.view',
  AdminManage = 'admin.manage',
  DashboardView = 'dashboard.view',
  DashboardManage = 'dashboard.manage',
}
export enum AssetAttributes {
  BreakingNews = 'breakingnews',
  RelevantNow = 'relevantnow',
  National = 'national',
}
export enum ConformStatus {
  NotReady = 'Not Ready',
  Pending = 'Pending',
  Processing = 'Processing',
  Ready = 'Ready',
  Error = 'Error',
  ClosedCaption = 'Closed Caption',
}
export enum JobStatus {
  Unknown = 'Unknown',
  Started = 'Started',
  Failed = 'Failed',
  Completed = 'Completed',
  Invalid = 'Invalid',
}
export enum IngestStatus {
  Ingesting = 'Started',
  IngestFailed = 'Faild',
  IngestCancelled = 'IngestCancelled',
  Ingested = 'Completed',
  Draft = 'Unknown',
  Publishing = 'Publishing',
  Published = 'Published',
  Deleted = 'Deleted',
}
export enum AssetSource {
  Ingest = 'Ingest',
  SubClip = 'SubClip',
  NestedChannel = 'NestedChannel',
  LiveStreamManager = 'LiveStreamManager',
  LiveEncoder = 'LiveEncoder',
  AdVariant = 'AdVariant',
  ClipGroup = 'ClipGroup',
  LiveEvent = 'LiveEvent',
}
export enum SizeUnits {
  Byte = 0,
  KB = 1,
  MB = 2,
  GB = 3,
  TB = 4,
  PB = 5,
  EB = 6,
  ZB = 7,
  YB = 8,
}

/**
 * =========== Channel Related ============
 */
export enum AdBreakType {
  BetweenContentOrAtAdCueMarker = 'BetweenContentOrAtAdCueMarker',
  AdsPerHour = 'AdsPerHour',
  DragAndDropAdBreak = 'DragAndDropAdBreak',
}
export enum ChannelType {
  Scheduled = 'Scheduled',
  Programmed = 'Programmed',
  Dynamic = 'Dynamic',
  NonstopNews = 'NonstopNews',
  LiveOnly = 'LiveOnly',
  Linear = 'Linear',
  External = 'External',
}
export enum ChannelAttributeType {
  TAG = 'tag',
  CATEGORY = 'cat',
  SYS = 'sys',
}
export enum AdBlockSize {
  SingleAd = 'Single Ad',
  AdPod = 'Ad Pod',
}
export enum LiveScheduleTransitionTypes {
  Ease = 'Ease',
  Cut = 'Cut',
}
export enum AssetTransitionType {
  IN_FROM_CONTENT = 'in-from-content',
  OUT_TO_CONTENT = 'out-to-content',
  IN_FROM_AD = 'in-from-ad',
  OUT_TO_AD = 'out-to-ad',
  AUTOMATED_TITLE = 'automated-title',
  IN_TITLE = 'in-title',
}
export enum ObjectChangeType {
  Created = 'Created',
  Updated = 'Updated',
  Deleted = 'Deleted',
}
export enum EventTopic {
  CHANNEL_CREATED = 'channel-created',
  ASSET_UPDATED = 'asset-updated',
  CHANNEL_UPDATED = 'channel-updated',
  CHANNEL_DELETED = 'channel-deleted',
}
export enum SourceFileType {
  VideoAndAudio = 'video',
  Caption = 'caption',
}
export enum OverlayAnchorType {
  Start = 'start',
  End = 'end',
}

export enum LiveJoinInProgress {
  JoinInProgress = 'join in progress',
  JoinFromBeginning = 'join from beginning',
}

export enum Permission {
  ApiAccess = 'ApiAccess',
  AnalyticsDashboard = 'AnalyticsDashboard',
  Dashboard = 'Dashboard',
  Ingest = 'Ingest',
  ListSearchAssets = 'ListSearchAssets',
  EditAsset = 'EditAsset',
  AdVariants = 'AdVariants',
  SubClip = 'SubClip',
  DeleteAsset = 'DeleteAsset',
  DownloadAsset = 'DownloadAsset',
  IngestRetry = 'IngestRetry',
  EditTagsCategories = 'EditTagsCategories',
  StartWithClip = 'StartWithClip',
  ChannelManager = 'ChannelManager',
  ListSearchChannels = 'ListSearchChannels',
  CreateChannel = 'CreateChannel',
  EditChannel = 'EditChannel',
  CopyChannel = 'CopyChannel',
  DeleteChannel = 'DeleteChannel',
  HaltChannel = 'HaltChannel',
  DisableChannel = 'DisableChannel',
  PreviewChannel = 'PreviewChannel',
  EditChannelInfo = 'EditChannelInfo',
  EnableAds = 'EnableAds',
  EditLiveTransitions = 'EditLiveTransitions',
  EditLODTransitions = 'EditLODTransitions',
  EditLODContent = 'EditLODContent',
  EditAdsSponsors = 'EditAdsSponsors',
  ListSearchLivePrograms = 'ListSearchLivePrograms',
  CreateLiveProgram = 'CreateLiveProgram',
  DeleteLiveProgram = 'DeleteLiveProgram',
  EditLiveProgramInfo = 'EditLiveProgramInfo',
  ListSearchAppEvents = 'ListSearchAppEvents',
  ListSearchProducts = 'ListSearchProducts',
  ListSearchPushNotifications = 'ListSearchPushNotifications',
  ListSearchMailchimp = 'ListSearchMailchimp',
  ListSearchFirebase = 'ListSearchFirebase',
  SCTETriggers = 'SCTETriggers',
  GeoFencing = 'GeoFencing',
  TimeZone = 'TimeZone',
  EditProgramLiveTransitions = 'EditProgramLiveTransitions',
  EditGeoFencing = 'EditGeoFencing',
  ListSearchTransitionTemplates = 'ListSearchTransitionTemplates',
  CreateTransitionTemplate = 'CreateTransitionTemplate',
  EditTransitionTemplate = 'EditTransitionTemplate',
  OUAdmin = 'OUAdmin',
  OUSuperAdmin = 'OUSuperAdmin',
  ClipTimeline = 'ClipTimeline',
  Chatbot = 'Chatbot',
  AdManagement = 'AdManagement',
  LayoutManagement = 'LayoutManagement',
  EventWorkflow = 'EventWorkflow',
}

export enum UIStage {
  Loading = 'loading',
  NoPermission = 'no-permission',
  Initialized = 'initialized',
}

export enum ActionbarAction {
  REFRESH = 'refresh',
  EDITASSET = 'editAsset',
  CLIP = 'clip',
  ADINSERTION = 'adInsertion',
  LINK = 'link',
  DELETEASSET = 'deleteAsset',
  DOWNLOADASSET = 'downloadAsset',
  PLAYPREVIEW = 'playPreview',
  EDITCHANNEL = 'editChannel',
  TOGGLE = 'toggle',
  HALTCHANNEL = 'halt',
  DELETECHANNEL = 'deleteChannel',
  RETRYINGEST = 'retryIngest',
  SHOW_INTAKE_MODAL = 'showIntakeModal',
  UPLOAD_WEB_VTT_FILE = 'uploadWebvttFile',
  DELETELIVEPROGRAM = 'deleteLiveProgram',
  EDITLIVEPROGRAM = 'editLiveProgram',
  RECOVERLIVEPROGRAM = 'recoverLiveProgram',
  EDITTEMPLATE = 'editTemplate',
  LIST = 'list',
}

export enum FuelTableColumnType {
  CHECKBOX = 'checkbox',
  THUMBNAIL = 'thumbnail',
  ACTIONBAR = 'actionbar',
  INGEST_STATUS = 'ingest-status',
  CONFORM_STATUS = 'conform-status',
}

export enum ChannelEditorStep {
  Info = 'info',
  AdsSponsors = 'ads-sponsors',
  LiveTransitions = 'live-transitions',
  AdBreakFillers = 'ad-break-fillers',
  VodInterstitials = 'vod-interstitials',
  VodContent = 'vod-content',
  Destinations = 'destinations',
  GeoFencing = 'geo-fencing',
  NewEPGGeneration = 'new-epg-generation',
  BroadcastEPGContent = 'broadcast-epg-content',
}
export enum ClipGroupStep {
  Info = 'info',
  Content = 'content',
}
export enum SeriesStep {
  Info = 'info',
  Content = 'content',
}
export enum AssetEventCategories {
  CRUDEvent = 'CRUDEvent', // events where the asset is created, updated, deleted, etc. (user triggered events)
  TranscodeEvent = 'TranscodeEvent', // system transcode events
}

export enum AssetEventType {
  Created = 'Created',
  Modified = 'Modified',
  Deleted = 'Deleted',
  IngestStarted = 'IngestStarted',
  TranscodeJobStarted = 'TranscodeJobStarted',
  TranscodeJobEnded = 'TranscodeJobEnded',
  LiveSegmentStarted = 'LiveSegmentStarted',
  LiveSegmentEnded = 'LiveSegmentEnded',
  Unknown = 'Unknown',
}

export enum AssetEventActionTypes {
  Restart = 'Restart',
  None = 'None',
}

export enum WebSocketActionType {
  keepAlive = 'keepAlive',
  connectToTopic = 'connectToTopic',
}
export enum MessageType {
  Unknown = 'Unknown',
  ConnectToTopic = 'ConnectToTopic',
  KeepAlive = 'KeepAlive',
  Notification = 'Notification',
}

export enum PushNotificationEventType {
  IngestStatusUpdate = 'IngestStatusUpdate',
  UILockStatusUpdate = 'UILockStatusUpdate',
}
